export default __webpack_public_path__ + "static/media/bra-arte-5.f48a5b3f.webp";